'use client'
import MyImage from '@/shared/components/myImage'
import { BLUR_DATA_URL_BASE64 } from '@/shared/constants'
import { getImgURL } from '@/shared/utils'
import { useState } from 'react'
import BreadcrumbNav from '../../breadcrumbNav'
// import BreadcrumbNav from '@/shared/components/breadcrumbNav'

type TeamHeaderProps = {
  name: string
  desc?: string
  team?: {
    aRanking?: any[]
    oImg?: {
      sUrl: string
    }
    sAbbr?: string
    oSeries?: {
      sGameFormat?: string
      nTotalMatches?: number
      nTotalTeams?: number
      dStartDate?: string | Date | number
      dEndDate?: string | Date | number
    }
  }
  showHeaderImg?: boolean
}

const TeamHeader = ({ name, desc, team }: TeamHeaderProps) => {
  const [showMore, setShowMore] = useState(false)

  const handleDesc = () => {
    setShowMore(!showMore)
  }

  return (
    <section>
      <div className="flex items-start justify-between mb-4">
        <BreadcrumbNav customTitle={name} />
      </div>
      <div className={` flex md:items-center gap-3`}>
        <div className="max-w-[68px] max-h-[68px] sm:max-w-[115px] sm:max-h-[115px] flex-shrink-0">
          <MyImage
            src={team?.oImg?.sUrl ? getImgURL(team?.oImg?.sUrl) : ''}
            alt={name}
            blurDataURL={BLUR_DATA_URL_BASE64}
            className="aspect-square rounded-full"
            placeholderType="team"
            placeholder="blur"
            height={115}
            width={115}
            sizes="(max-width: 767px) 80px, (max-width: 991px) 80px, (max-width: 1190px) 200px, 80px"
          />
        </div>

        <div className={`flex flex-wrap justify-center flex-col text-xs relative z-[1] mt-4`}>
          <span className=" absolute top-2/4 -translate-y-2/4 left-0 md:-left-2.5 text-[99px] md:text-[140px] -z-[1] font-bold text-[#646A6E] opacity-[10%] uppercase">
            {team?.sAbbr}
          </span>
          <h1 className="m-0  text-base md:leading-none md:text-32px md:font-bold my-0">{name}</h1>
          <div className="mt-4 md:mt-[22px] flex items-start gap-3">
            {team?.aRanking?.map(rank => {
              return (
                <p
                  key={rank.eMatchType}
                  className={
                    'py-1.5 px-3 capitalize text-xxs md:text-sm font-medium flex flex-wrap items-center text-subSectionText border border-tabBorder rounded-md md:rounded-[9px] last:me-0'
                  }
                >
                  {`#${rank.nRank} in ${rank.eMatchType}`}
                </p>
              )
            })}
          </div>
        </div>
      </div>
      {desc && (
        <div
          className={`${!showMore && 'box h-32 overflow-hidden text-ellipsis '} big-text`}
          dangerouslySetInnerHTML={{ __html: desc }}
        ></div>
      )}

      {desc && desc.length > 550 && (
        <div>
          <a
            className={'text-primary-500 hover:text-primary-500 sm:px-1 sm:py-2.5 sm:text-xs'}
            onClick={handleDesc}
          >
            {showMore ? 'Read Less' : 'Read More'}
          </a>
        </div>
      )}
    </section>
  )
}

export default TeamHeader
